import { createFileRoute } from '@tanstack/react-router';
import { CentrosPage, lerBuscaCentros } from '@/components/centros-custo';

export const Route = createFileRoute('/_app/custos/centros')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaCentros(bruto),
  component: CentrosRota,
});

function CentrosRota() {
  return <CentrosPage busca={Route.useSearch()} />;
}
